import React, { useEffect, useState } from 'react';
import { Alert, AlertTitle, Typography } from '@mui/material';
import packages, { apiError } from 'common/packages';

// Co-located with the block it renders: all three package views ask the same
// question and render the same answer to it.
//
// isManager is null until known. error is set when the check itself failed —
// which is not the same thing as being off the allowlist, and must not render
// the explanatory block.
export function usePackageManager() {
  const [state, setState] = useState({ isManager: null, error: null });

  useEffect(() => {
    let active = true;
    packages
      .permissions()
      .then((data) => {
        if (active) {
          setState({ isManager: data && data.is_package_manager === true, error: null });
        }
      })
      .catch((error) => {
        if (active) setState({ isManager: null, error: apiError(error) });
      });
    return () => {
      active = false;
    };
  }, []);

  return state;
}

const NotPackageManager = () => (
  <Alert severity="info" sx={{ maxWidth: 720 }}>
    <AlertTitle>Package management is restricted</AlertTitle>
    <Typography variant="body2" gutterBottom>
      Listing, uploading and publishing licensed application packages requires
      being on the <code>Accounts:PackageManagers</code> allowlist. Your admin
      account is signed in, but it is not on that list, so the API will refuse
      every read and write on this screen.
    </Typography>
    <Typography variant="body2">
      Ask the api-accounts maintainers to add your account UUID to
      <code> Accounts:PackageManagers</code> in the environment's configuration.
      It is a deploy-time setting, not something this portal can grant.
    </Typography>
  </Alert>
);

export default NotPackageManager;
